/*
 NOTE: this should closely match js/widgets/generators/tpl/menuRefinement.js -> refinementItem
 */
export const numericItem = `
  <label class="text-sm text-gray-600 flex items-center cursor-pointer">
    <input type="radio" class="h-5 w-5 border-gray-300 text-blue-500 focus:ring-2" {{#isRefined}}checked="true"{{/isRefined}}>
      <span class="ml-3 ">{{label}}</span>
  </label>
`

export const numericClasses = {
  root: 'pb-5',
  list: [
    'py-1',
  ],
}
